import React from 'react'

import { connect } from "react-redux"

import { Form } from 'react-form'

import { Card } from 'primereact/card'

import EmployeeTable from '../components/employee/employee-table'
import EmployeeDetails from '../components/employee/employee-details'

import { EMPLOYEE_TYPE_UNDERTAKING, EMPLOYEE_TYPE_OTHER, ROLE_ADMIN } from "../js/const"
import { downloadFile } from '../js/file'

import * as lookupCodeActionCreators from "../actionCreators/lookupCode"
import * as employeeActionCreators from "../actionCreators/employee"
import * as appActionCreators from "../actionCreators/app"

class Employee extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDisplayingUndertakingEmployeeDialog: false, // determines whether persons undertaking lobbyist employee details dialog is hidden or shown
            isDisplayingOtherEmployeeDialog: false, // determines whether other employee details dialog is hidden or shown
            selectedUndertakingEmployee: {}, // determines which persons undertaking lobbyist employee  employee is selcted in the table. It will be highlighted
            selectedOtherEmployee: {} // determines which other employee is selcted in the table. It will be highlighted
        }
        this.statDecUpload = React.createRef()
    }

    // this function will be called when the form is submitted successfully
    // the employee object passed is in the same structure as the object bound to <Form> values property
    // the object will have been updated based on user input
    formSubmittedSuccessfully = (employee, type) => {
        employee.StartDate = employee.StartDate ? new Date(employee.StartDate) : null
        employee.EndDate = employee.EndDate ? new Date(employee.EndDate) : null
        employee.RestrictionStartDate = employee.RestrictionStartDate ? new Date(employee.RestrictionStartDate) : null
        employee.RestrictionEndDate = employee.RestrictionEndDate ? new Date(employee.RestrictionEndDate) : null
        // depending on the type of employee stat dec might not be available
        if (this.statDecUpload && this.statDecUpload.current) {
            let files = this.statDecUpload.current.state.files
            if (files && files.length > 0) {
                let statDec = files[0]
                employee.StatDecFileData = statDec
                employee.StatDecFilename = statDec.name
            }
        }

        // if id exists then we are updating otherwise we are adding
        // use actionCreators that have been injected in as props. This happens when the higher order component connect is used
        if (employee.EmployeeId) {
            this.saveEmployee(employee, type, this.props.updateEmployee)
        } else {
            employee.LobbyistId = this.props.lobbyistId
            this.saveEmployee(employee, type, this.props.addEmployee)
        }
    }

    saveEmployee = (employee, type, save) => {
        this.props.setLoading(true)
            .then(() => save(employee))
            .then(response => {
                // set response in store so global response component can handle response
                /*
                    response json structure is:
                    {
                        "$id":"1",
                        "SuccessOutput":null,
                        "Success":false,
                        "ErrorMessages":{
                            "$id":"2",
                            "$values":[
                                "Name is required"
                            ]
                        },
                        "WarningMessages":{
                            "$id":"3",
                            "$values":[
        
                            ]
                        }
                    }
                */
                this.props.setAjaxResponse(response)
                if (response.data.Success) {
                    this.closeEmployeeDetails(type)
                }
            })
            .then(() => this.props.setLoading(false))
            .catch((error) => this.props.handleError(error)
                .then(() => this.props.setLoading(false)))

    }

    addEmployee = type => this.loadAndOpenEmployeeDetails(null, type)
    selectEmployee = (e, type) => this.loadAndOpenEmployeeDetails(e.data, type)

    loadAndOpenEmployeeDetails = (employee, type) => {
        let employeeId = employee ? employee.EmployeeId : null
        this.props.setLoading(true)
            .then(() => {
                // load restriction lookup codes for drop down
                return this.props.getEmployeeRestrictions()
            })
            .then(() => {
                // load employee view model to get validation rules
                return this.props.getEmployee({ employeeId, type })
            })
            .then(() => {
                // show dialog and higlight selected client
                // open pop up. check type to see which pop up to open
                if (type === EMPLOYEE_TYPE_UNDERTAKING) {
                    this.setState({ isDisplayingUndertakingEmployeeDialog: true, selectedUndertakingEmployee: employee || {} })
                } else if (type === EMPLOYEE_TYPE_OTHER) {
                    this.setState({ isDisplayingOtherEmployeeDialog: true, selectedOtherEmployee: employee || {} })
                }
            })
            .then(() => this.props.setLoading(false))
            .catch((error) => this.props.handleError(error)
                .then(() => this.props.setLoading(false)))
    }

    closeEmployeeDetails = (type, resetForm) => {
        if (resetForm) {
            // reset form to initial state to clear validation errors and bound value
            resetForm()
        }

        // close pop up. check type to see which pop up to close
        if (type === EMPLOYEE_TYPE_UNDERTAKING) {
            this.setState({ isDisplayingUndertakingEmployeeDialog: false, selectedUndertakingEmployee: {} })

            // clear any file that had been selected so next time dialog is open it will be in the default state
            // this will be undefined if viewing in read only mode
            if (this.statDecUpload && this.statDecUpload.current) {
                this.statDecUpload.current.clear()
            }
        } else if (type === EMPLOYEE_TYPE_OTHER) {
            this.setState({ isDisplayingOtherEmployeeDialog: false, selectedOtherEmployee: {} })
        }

        // clear loaded employee in store since we are done with it
        this.props.clearEmployee()
    }

    deleteEmployee = (type, employeeId) => {
        if (employeeId) {
            this.props.setLoading(true)
                .then(() => this.props.deleteEmployee(employeeId))
                .then(response => {
                    // set response in store so global response component can handle response
                    this.props.setAjaxResponse(response)
                    if (response.data.Success) {
                        // close dialog by calling function that has been passed in by containing component
                        // this is because the state that determines whether the dialog is showing is in the containing component
                        this.closeEmployeeDetails(type)
                    }
                })
                .then(() => this.props.setLoading(false))
                .catch((error) => this.props.handleError(error)
                    .then(() => this.props.setLoading(false)))
        }
    }

    downloadStatDec = (e, employeeId) => {
        e.preventDefault()
        if (employeeId) {
            // show loading icon since we are doing an ajax call
            this.props.setLoading(true)
                .then(() => this.props.getEmployeeStatDec(employeeId))
                .then((response) => {
                    var fileData = new Blob([response.data])

                    // get filename from the content disposition header that is set server side
                    let contentDisposition = response.headers['content-disposition']
                    let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1)
                    downloadFile(fileData, filename)

                    this.props.setLoading(false)
                })
                .catch((error) => this.props.handleError(error)
                    .then(() => this.props.setLoading(false)))
        }
    }

    render() {
        // check if current employee that is being looked at exists. If not create an empty object to deal with issues that could be caused by employee being undefined
        // i.e. when binding to employee.Entity.EmployeeName there could be issues when employee is undefined since we are trying to access a property off of a propery
        let currentEmployee = this.props.employee.currentEmployee ? this.props.employee.currentEmployee : {}

        let employees = this.props.employee.lobbyistEmployees ? this.props.employee.lobbyistEmployees : []
        let lobbyistEmployees = employees.filter(employee => employee.EmployeeTypeCode === EMPLOYEE_TYPE_UNDERTAKING)
        let otherEmployees = employees.filter(employee => employee.EmployeeTypeCode === EMPLOYEE_TYPE_OTHER)

        let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

        let employeeDetailsProps = {
            canSave: this.props.canSave,
            canSeePrivateData: this.props.canSeePrivateData,
            currentEmployee: currentEmployee,
            closeEmployeeDetails: this.closeEmployeeDetails,
            employeeRestrictions: this.props.lookupCode.employeeRestrictions,
            downloadStatDec: this.downloadStatDec,
            deleteEmployee: this.deleteEmployee,
            statDecUpload: this.statDecUpload,
            isAnnualReturn: false,
            isAdmin: isAdmin
        }

        let employeeTableProps = {
            canSave: this.props.canSave,
            selectEmployee: this.selectEmployee,
            addEmployee: this.addEmployee,
            isAnnualReturn: false
        }
        return (
            <React.Fragment>
                <Card title="People Undertaking Lobbyist Activities" 
                subTitle="">
                <div className="p-card-subtitle">
                    <p>Please Note:</p>
                    <ul>
                        <li>Registration will not be accepted until at least one person is added to this table.</li>
                        <li>All individuals added to this table are required to provide a Statutory Declaration in PDF form.</li>
                        <li>Only alpha numeric characters and _-() are allowed in the filename.</li>
                        <li>End date should only be entered when person ceases employment with the Lobbyist organisation.</li>
                    </ul>
                </div>

                    <EmployeeTable employees={lobbyistEmployees} selectedEmployee={this.state.selectedUndertakingEmployee} type={EMPLOYEE_TYPE_UNDERTAKING}
                        {...employeeTableProps}></EmployeeTable>
                    {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                    this is useful when needed to clear the form or populating the form from another component
                    onSubmit is called when the form has been submitted and has passed validation
                    formApi properties can be found at https://react-form.js.org/#/*/}
                    <Form values={currentEmployee} onSubmit={employee => this.formSubmittedSuccessfully(employee, EMPLOYEE_TYPE_UNDERTAKING)}>
                        {formApi => {
                            employeeDetailsProps.submitForm = formApi.submitForm
                            employeeDetailsProps.resetForm = formApi.resetAll
                            employeeDetailsProps.isDisplayingDialog = this.state.isDisplayingUndertakingEmployeeDialog
                            employeeDetailsProps.type = EMPLOYEE_TYPE_UNDERTAKING
                            employeeDetailsProps.statDecError = this.state.statDecError
                            return (
                                <EmployeeDetails {...employeeDetailsProps} />
                            )
                        }
                        }
                    </Form>
                </Card>
                <Card title="Other Employees" 
                subTitle="List employees of the registered company/organisation that DO NOT undertake any lobbying activities. 
                A statutory declaration is not required for these employees. 
                End date should only be completed when employee ceases employment with the organisation.">
                    <EmployeeTable employees={otherEmployees} selectedEmployee={this.state.selectedOtherEmployee} type={EMPLOYEE_TYPE_OTHER}
                        {...employeeTableProps}></EmployeeTable>
                    {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                    this is useful when needed to clear the form or populating the form from another component
                    onSubmit is called when the form has been submitted and has passed validation
                    formApi properties can be found at https://react-form.js.org/#/*/}
                    <Form values={currentEmployee} onSubmit={employee => this.formSubmittedSuccessfully(employee, EMPLOYEE_TYPE_OTHER)}>
                        {formApi => {
                            employeeDetailsProps.submitForm = formApi.submitForm
                            employeeDetailsProps.resetForm = formApi.resetAll
                            employeeDetailsProps.isDisplayingDialog = this.state.isDisplayingOtherEmployeeDialog
                            employeeDetailsProps.type = EMPLOYEE_TYPE_OTHER
                            return (
                                <EmployeeDetails {...employeeDetailsProps} />
                            )
                        }
                        }
                    </Form>
                </Card>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    let { employee, lookupCode, auth } = state
    return { employee, lookupCode, auth }
}

// this is how to combine actions available
const actionCreators = {
    ...appActionCreators,
    ...employeeActionCreators,
    ...lookupCodeActionCreators
}

export default connect(mapStateToProps, actionCreators)(Employee);


// WEBPACK FOOTER //
// ./src/container/Employee.js